import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import moment from "moment";
import { useNavigate, Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

function BlogListpub2() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const blog_list = useSelector((state) =>
    state?.allapi?.blog_list ? state?.allapi?.blog_list : {}
  );

  useEffect(() => {
    dispatch(allapiAction.getBlogListPub(1));
    dispatch(allapiAction.getrectentBlog({}));
  }, [dispatch]);

  const recentlisting = blog_list?.docs || [];

  return (
  <div style={{ padding: "30px 15px", background: "#f8f9fa" }}>
  
  {/* Heading */}
  <h2
    style={{
      fontWeight: "700",
      marginBottom: "25px",
      textAlign: "center",
      fontSize: "28px"
    }}
  >
    Our Blog
  </h2>

  {/* Blog Grid */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "25px"
    }}
  >
    {recentlisting.slice(0, 3).map((data, index) => (
      
      <div
        key={index}
        onClick={() => navigate("/blog-details/" + data?.slug)}
        style={{
          background: "#fff",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
          cursor: "pointer",
          transition: "0.3s"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-8px)";
          e.currentTarget.style.boxShadow =
            "0 15px 35px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow =
            "0 6px 20px rgba(0,0,0,0.08)";
        }}
      >

        {/* Image */}
        <div style={{ overflow: "hidden" }}>
          <img
            src={URL?.API_BASE_URL + data?.feature_image}
            alt={data?.title}
            style={{
              width: "100%",
              height: "200px",
              objectFit: "cover",
              transition: "0.4s"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.08)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          />
        </div>

        {/* Content */}
        <div style={{ padding: "18px" }}>
          
          {/* Date */}
          <p
            style={{
              fontSize: "14px",
              color: "#888",
              marginBottom: "8px"
            }}
          >
            {moment(data?.createdAt).format("MMMM DD, YYYY")}
          </p>

          {/* Title */}
          <h4
            style={{
              fontWeight: "700",
              fontSize: "20px",
              marginBottom: "10px",
              lineHeight: "1.4",
              height: "56px",
              overflow: "hidden"
            }}
          >
            {data?.title}
          </h4>

          {/* Description */}
          <p
            style={{
              fontSize: "15px",
              color: "#555",
              lineHeight: "1.6",
              height: "70px",
              overflow: "hidden",
              marginBottom: "12px"
            }}
          >
            {data?.short_description}
          </p>

          {/* Read More */}
          <span
            style={{
              fontWeight: "600",
              color: "#007bff",
              fontSize: "15px"
            }}
          >
            Read Full Article →
          </span>

        </div>

      </div>

    ))}
  </div>
</div>
  );
}

export default BlogListpub2;
